export const TOTAL_LAYERMASK = 1;
export const DETAIL_LAYERMASK = 2;
export const HIDDEN_LAYERMASK = 4;
